import React, { useEffect } from 'react';
import { arrayOf, bool, object } from 'prop-types';
import { useDispatch } from 'react-redux';

import BatchProgressDialog from './BatchProgressDialog';
import { enqueueSnackbar } from '../../actions/applicationMessageActions';
import { getRule, saveRule } from '../../actions/ruleActions';
import useQueue from '../../hooks/useQueue';

const RuleDuplicateSelectedModal = ({ onClose, open, rules }) => {
    const dispatch = useDispatch();
    const [queue, runQueue] = useQueue(async (rule, { fulfill, reject}) => {
        try {
            const rulePayload = await dispatch(getRule(rule.id));
            const updatedRule = await dispatch(saveRule({
                ...rulePayload.data,
                id:   undefined,
                name: `Copy of ${rule.name}`
            }));
            fulfill({
                item:  rulePayload.data,
                value: updatedRule
            });
        } catch (error) {
            reject({
                error,
                item: rule
            });
        }
    });

    useEffect(() => {
        if (open) {
            runQueue(rules);
        }
    }, [open]);

    useEffect(() => {
        if (queue.complete && queue.successful) {
            dispatch(
                enqueueSnackbar('Rule(s) duplicated successfully!', 'success')
            );
            onClose();
        }
    }, [queue.complete, queue.successful]);

    return (
        <BatchProgressDialog
            {...queue}
            onClose={onClose}
            open={open}
            title="Duplicating Selected Rules..."
        />
    );
};

RuleDuplicateSelectedModal.defaultProps = {
    open:  false,
    rules: []
};

RuleDuplicateSelectedModal.propTypes = {
    open:  bool,
    rules: arrayOf(object)
};

export default RuleDuplicateSelectedModal;
